import * as yup from 'yup';

const nullableNumber = (value: string, originalValue: string) =>
    originalValue.trim() === '' ? null : value;

const ResetPeriodSchema = {
    limit_duration: yup.string().when('type', {
        is: (value: string) => value !== 'restriction',
        then: yup.string().required('FLEXCONTROLSDURATION'),
    }),
    week_day: yup.string().when('limit_duration', {
        is: 'weekly',
        then: yup.string().required('FLEXCONTROLSWEEK'),
    }),
    month_day: yup
        .number()
        .typeError('FLEXCONTROLMONTHDAYRANGE')
        .min(1, 'FLEXCONTROLMONTHDAYRANGE')
        .max(28, 'FLEXCONTROLMONTHDAYRANGE')
        .when('limit_duration', {
            is: 'monthly',
            then: yup
                .number()
                .typeError('FLEXCONTROLSMONTH')
                .min(1, 'FLEXCONTROLMONTHDAYRANGE')
                .max(28, 'FLEXCONTROLMONTHDAYRANGE')
                .required('FLEXCONTROLSMONTH'),
            otherwise: yup
                .number()
                .typeError('FLEXCONTROLMONTHDAYRANGE')
                .nullable()
                .transform(nullableNumber),
        }),
    time: yup.string().when('limit_duration', {
        is: true,
        then: yup.string().required(),
    }),
};

export default ResetPeriodSchema;
